<div class="container">
  <div class="header">
    <div class="title">{{ rewardId ? labels.editReward : labels.addReward }}</div>
  </div>
  <div class="divider"></div>
  <div class="form">
    <div class="form-container" [class.loading-active]="loading">
      <span class="edit-disclaimer">{{rewardId ? labels.editDisclaimer : labels.addDisclaimer }}</span>
      <app-product-stepper #stepper
                           [formValid]="isStepValid"
                           [isEditing]="isEditing"
                           [titles]="[labels.step1Title, labels.step2Title, labels.step3Title]">
        <ng-template appProductStep>
          <div class="step-content">
            <app-reward-details-form [formGroup]="getForm(1)"
                                     [availableFamilies]="availableFamilies"
                                     [availableBusinessLevels]="availableBusinessLevels"
                                     [rewardId]="rewardId">
            </app-reward-details-form>
          </div>
        </ng-template>
        <ng-template appProductStep>
          <div class="step-content">
            <div class="loading-container" *ngIf="regionLoading">
              <div class="skeleton-checkbox-wrapper" *ngFor="let i of [1, 2, 3, 4]">
                <div class="skeleton-region-title"></div>
                <div class="skeleton-checkbox-group">
                  <div class="skeleton-checkbox"
                       *ngFor="let j of [1, 2, 3, 4]">
                  </div>
                </div>
              </div>
            </div>
            <app-region-target-form [formGroup]="getForm(2)"
                                    [regionList]="regionList">
            </app-region-target-form>
          </div>
        </ng-template>
        <ng-template appProductStep>
          <div class="step-content">
            <app-reward-overview-form [formGroup]="rewardForm"
                                      [availableFamilies]="availableFamilies"
                                      [availableBusinessLevels]="availableBusinessLevels"
                                      [rewardId]="rewardId">
            </app-reward-overview-form>
          </div>
        </ng-template>
      </app-product-stepper>
      <div *ngIf="loading" class="loading-overlay">
        <mat-spinner diameter="50"></mat-spinner>
      </div>
    </div>
  </div>
  <div class="footer">
    <button mat-stroked-button color="primary" (click)="goBack()">
      <nb-icon icon="close-outline"></nb-icon>{{ labels.cancel }}
    </button>
    <div class="back-next-button">
      <button mat-stroked-button
              color="primary"
              (click)="stepper.prev()"
              *ngIf="stepper.currentStep > 0">
        <nb-icon icon="arrow-back-outline"></nb-icon>
        {{ labels.back }}
      </button>
      <button mat-flat-button
              color="primary"
              [disabled]="!isStepValid || isEditing"
              (click)="stepper.next()"
              *ngIf="stepper.currentStep < 2">
        <nb-icon icon="arrow-forward-outline"></nb-icon>
        {{ labels.next }}
      </button>
      <button mat-flat-button
              color="primary"
              [disabled]="!rewardForm.valid"
              (click)="handleSendReward()"
              *ngIf="stepper.currentStep === 2">
        <nb-icon icon="checkmark-outline"></nb-icon>
        {{ rewardId ? labels.update : labels.create }}
      </button>
    </div>
  </div>
</div>
